import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import RegisterTutor from "./pages/RegisterTutor";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import TutorProfile from "./pages/TutorProfile";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Donate from "./pages/Donate";
import Contact from "./pages/Contact";
import TutoringProgram from "./pages/tutoring-program";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./pages/AdminDashboard";   // ← ADD THIS\
import Run from "./pages/Run";  // ← ADD THIS (optional page for testing video banner)
   import Pending from "./pages/Pending";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<RegisterTutor />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/tutoring-program" element={<TutoringProgram />} />
        <Route path="/tutors/:id" element={<TutorProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminDashboard />} />  {/* ← ADD THIS */}
        <Route path="/run" element={<Run />} />  {/* ← ADD THIS (optional page for testing video banner) */}
<Route path="/pending" element={<Pending />} />
      </Routes>
    </BrowserRouter>
  );
}